module.exports = __webpack_public_path__ + "img/Group 203.035f39d8.png";